import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem } from '@marriott/mi-ui-library';
import { constants } from '../../modules/utils/constants/constants';

export const StyledBestOfComponent = styled.div`
  .best-of-viewall-link {
    &::after {
      line-height: inherit;
    }
  }
  ${rtl`
        &:is(${constants.RTL_LANG_LIST}) {
        .carouselControlType1 .left-arrow {
          right:auto;
          left: ${toRem(-20)};
        }

        .chevronContainer[class*="icon-arrow-"]::before {
          left: ${toRem(20)} !important;
          right: auto;
        }
        .carouselControlType1 .right-arrow {
          left: auto;
          right: ${toRem(-20)};
        }
      }
  `}
`;
